import React from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { updateSMDData, postSMDAttachment } from "../Actions/SMDNewEditItem";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "glamor";
import $ from "jquery";
toast.configure();
class SMDEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            SMDPostArray: { 
                supplierMaterialDeclarationId: 0, 
                companyName: '', 
                attachmentName: '', 
                attachmentGuid: '', 
                attachmentId: '', 
                modifiedBy: '', 
                isDeleted: false 
            },
            file: '',
        }
        this.UpdateSMDData = this.UpdateSMDData.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.ClearInput = this.ClearInput.bind(this);
    }
    // static getDerivedStateFromProps(nextProps, prevState) {
    //     ;
    //     const { dispatch } = nextProps;
    //     if (nextProps.arraylist !== prevState.arraylist) {
    //         prevState.arraylist = nextProps.arraylist;
    //         prevState.SMDPostArray.supplierMaterialDeclarationId = nextProps.arraylist.supplierMaterialDeclarationId;
    //         prevState.SMDPostArray.companyName = nextProps.arraylist.companyName;
    //         if (nextProps.arraylist.hasOwnProperty("smdattachmentDTOs")) {
    //             if (nextProps.arraylist.smdattachmentDTOs.length > 0) {
    //                 prevState.SMDPostArray.attachmentId = nextProps.arraylist.smdattachmentDTOs[0].attachmentId;
    //                 prevState.SMDPostArray.attachmentName = nextProps.arraylist.smdattachmentDTOs[0].attachmentName;
    //                 prevState.SMDPostArray.attachmentGuid = nextProps.arraylist.smdattachmentDTOs[0].attachmentGuid;
    //             }
    //         }
    //         prevState.SMDPostArray.modifiedBy = nextProps.userDisplayName;
    //     }
    //     if (nextProps.SMDAttachmentData !== '' && nextProps.SMDAttachmentData !== prevState.SMDAttachmentData) {
    //         prevState.SMDAttachmentData = nextProps.SMDAttachmentData;
    //         prevState.SMDPostArray.attachmentName = nextProps.SMDAttachmentData.FileName;
    //         prevState.SMDPostArray.attachmentGuid = nextProps.SMDAttachmentData.Guid;
    //         dispatch(updateSMDData(prevState.SMDPostArray));
    //         dispatch({ type: 'IsSMDEdit', data: false });
    //     }
    // }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { arraylist, dispatch, SMDAttachmentData } = nextProps;
        if (arraylist && arraylist !== "") {
            prevState.SMDPostArray.supplierMaterialDeclarationId = arraylist.supplierMaterialDeclarationId;
            prevState.SMDPostArray.companyName = arraylist.companyName;
            prevState.SMDPostArray.modifiedBy = nextProps.userDisplayName;
            prevState.SMDPostArray.attachmentName = arraylist.attachmentName;
            prevState.SMDPostArray.attachmentGuid = arraylist.attachmentGuid;
            prevState.SMDPostArray.attachmentId = arraylist.attachmentId;
            dispatch({ type: "IsSMDEdit", data: '' });
            // prevState.fileName = arraylist.attachmentName;
            // dispatch({ type: "IsSMDEdit", data: null });
        }
        if (SMDAttachmentData) {
            prevState.SMDPostArray.attachmentName = SMDAttachmentData.FileName;
            prevState.SMDPostArray.attachmentGuid = SMDAttachmentData.Guid;
            prevState.file = ''
        }
    }

    handleInputChange(e) {
        let nodeName = e.target.name;
        if (nodeName === "fileName") {
            console.log(e.target.files[0])
            e.target.files[0].name.trim() !== "" ? $("#SMDFileEditErrMsg").text("") : $("#SMDFileEditErrMsg").text("This field is required");
            this.state.SMDPostArray.attachmentName = e.target.files[0].name;
            this.state.file = e.target.files[0];
            this.setState({ SMDPostArray: this.state.SMDPostArray });
            this.props.dispatch(postSMDAttachment(e.target.files[0]))
        } else {
            e.target?.value.trim() !== "" ?  $("#SMDNameEditErrMsg").text("") : $("#SMDNameEditErrMsg").text("This field is required");
            this.state.SMDPostArray[nodeName] = e.target.value;
            this.setState({});
        }
    }

    UpdateSMDData(){
        const { dispatch, history } = this.props;
            if (this.state.SMDPostArray.attachmentName.trim() == "" || this.state.SMDPostArray.companyName.trim() == ""){
                this.state.SMDPostArray.companyName.trim() == "" ? $("#SMDNameEditErrMsg").text("This field is required") : $("#SMDNameEditErrMsg").text("");
                this.state.SMDPostArray.attachmentName.trim() == "" ? $("#SMDFileEditErrMsg").text("This field is required") : $("#SMDFileEditErrMsg").text("");
            } else {
                $("#SMDNameEditErrMsg").text("");
                $("#SMDFileEditErrMsg").text("");
                dispatch(updateSMDData(this.state.SMDPostArray));
                history.goBack()
            }
            // this.props.dispatch({ type: 'IsSMDEdit', data: null });
            // this.props.history.push("/Home/SMDLibray")
    }

    ClearInput() {
    let clearData = { FileName: "", Guid: "" }
        this.props.dispatch({
            type: "SMDAttchmentUploadSuccess",
            data: clearData,
        })
        $("#SMDFileEditErrMsg").text("This field is required")
    }

    CancelSMD() {
        this.props.history.push("/Home/SMDLibray");
        this.props.dispatch({ type: 'IsSMDEdit', data: false });
        this.props.dispatch({ type: "SMDEditing", data: false })
    }
    render() {

        return (
            <div className="full-height w-100">
                <div className="grey-bg  course-list-page pt-3">
                    <div className="px-4">
                        <div className="panel-box search-filter-box mb-4">
                            <div className="row">
                                <div className="col-lg-6">
                                    <label className="form-label required" >Company Name</label><br></br>
                                    <input className="form-control" type="text" id="companyname" name="companyName" onChange={(e) => this.handleInputChange(e)} value={this.state.SMDPostArray.companyName}></input>
                                    <span id="SMDNameEditErrMsg" className="spanErrMsg ml-2"></span>
                                </div>
                                <div className="col-lg-6">
                                    <label className="form-label required" >File</label><br></br>
                                    {/* <div class="input-group mb-3">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">Browse File<input type="file" id="files" name="fileName" title=" " onChange={(e) => this.handleInputFileChange(e)} /></span>
                                        </div>
                                        <input type="text" class="form-control" placeholder="" name="username" value={this.state.SMDPostArray.attachmentName} />
                                        {
                                            this.state.SMDPostArray.attachmentName ? <div class="input-group-append">
                                                <i class="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.ClearInput()}></i>
                                            </div> : ''
                                        }

                                    </div> */}
                                    <div class="input-group ">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">Browse File<input type="file" id="files"  style={{ marginRight: 40 }} name="fileName" onChange={e => this.handleInputChange(e)}
                                                onClick={(event) => { event.currentTarget.value = null }}
                                            /></span>
                                        </div>
                                        <input type="text" class="form-control" placeholder="No file chosen" value={this.state.SMDPostArray.attachmentName} />
                                        {
                                            this.state.SMDPostArray.attachmentName ?
                                            <div class="input-group-append" style={{cursor:"pointer"}}>
                                                <i class="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.ClearInput()}></i>
                                            </div> : ''
                                        }
                                    </div>
                                    <span id="SMDFileEditErrMsg" className="spanErrMsg ml-2"></span>
                                </div>
                                <div className="col-lg-12 py-3">
                                    <div className="search-btn-col" style={{ textAlign: 'end' }}>
                                        <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.UpdateSMDData()}> Update </button>

                                        <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.CancelSMD()}> Cancel </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {

    return {
        arraylist: state.SidePanReducer.IsSMDEdit,
        userDisplayName: state.SidePanReducer.userDisplayName,
        SMDAttachmentData: state.SidePanReducer.SMDAttachmentData,
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SMDEdit));